<template>
    <div style="background-color:#F8F8F8;overflow: hidden;">
        <div class="login_header" style="background-color: #fff;">
            <div class="logo">
                <img src="../../assets/img/logo.png" alt="" style="width: 100%;height: 100%;">
            </div>
            <el-button class="dengluBtn" @click="backBtn">{{ $t('meg.loginPage') }}</el-button>
        </div>
        <div class="trends">
            <p style="font-size: 57px;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 500;color: #FFFFFF;">
                忘记密码</p>
            <p
                style="font-size: 20px;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 400;color: #FFFFFF;margin-top: 18px;">
                请根据您的身份来填写信息，审核后登录系统</p>
        </div>
        <div style="margin: 35px 440px;">
            <div class="kehuzhuce">忘记密码</div>
        </div>
        <div style="margin: 35px 38%;">
            <el-steps :space="200" class="cus-steps" :active="active" align-center>
                <el-step title="验证邮箱" />
                <el-step title="修改密码" />
            </el-steps>
        </div>
        <div class="yanzhengxinxi" v-if="active == 1">
            <h1 class="title">验证信息</h1>
            <div style="margin-top: 28px;margin-left: 60px;">
                <el-form label-width="100" label-position="left" :rules="rules" :model="registerForm">
                    <el-form-item prop="useName" label="用户名" required>
                        <el-input v-model="registerForm.useName" />
                    </el-form-item>
                    <el-form-item prop="email" label="邮箱" required>
                        <el-input v-model="registerForm.email" />
                    </el-form-item>
                    <el-form-item label="验证码" required prop="code">
                        <el-input style="width: 144px;" v-model="registerForm.code" />
                        <el-button @click="sendVerificationCode" :disabled="!canSendCode" class="yanzhengBtn">{{
                            canSendCode ? '发送验证码' :
                            `重新发送(${countdown}s)` }}</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="yanzhengxinxi" v-if="active == 2">
            <h1 class="title">修改信息</h1>
            <div style="margin-top: 28px;margin-left: 60px;">
                <el-form label-width="100" label-position="left" :rules="formrules" :model="passwordForm">
                    <el-form-item prop="password" label="新密码" required >
                        <el-input v-model="passwordForm.password" />
                    </el-form-item>
                    <el-form-item prop="confirmPassword" label="确认新密码" required>
                        <el-input v-model="passwordForm.confirmPassword" />
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div v-if="active == 1"
            style="height: 81px;background-color: #fff;border-radius: 10px 10px 10px 10px;opacity: 1;margin: 12px 440px;text-align: left;margin-bottom: 50px;">
            <el-button class="next" @click="next">下一步</el-button>
        </div>
        <div v-if="active == 2"
            style="height: 81px;background-color: #fff;border-radius: 10px 10px 10px 10px;opacity: 1;margin: 12px 440px;text-align: left;margin-bottom: 50px;">
            <el-button class="next" @click="confirm">确认</el-button>
        </div>
    </div>
</template>

<script setup>
import { sendCode1, forgetPassword,changePassword } from "@/api/login.js"
import { ref, reactive } from 'vue'
import { ElMessage } from 'element-plus'
import { useRouter } from 'vue-router';

const active = ref(1)
const router = useRouter()
const canSendCode = ref(true)
const countdown = ref(60)
const registerForm = reactive({
    useName: "",
    email: "",
    code: "",
    
})

const passwordForm = reactive({
    password: "",
    confirmPassword: "",
})
const validateConfirmPassword = async (rule, value) => {
    if (value !== passwordForm.password) {
        throw new Error('两次输入密码不一致');
    }
};
const rules = {
    useName: [{ required: true, message: '请输入用户名', trigger: 'blur' },
    ],
    email: [
        { required: true, message: '请输入邮箱', trigger: 'blur' },
        {
            pattern: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
            message: '请输入正确的邮箱格式',
            trigger: 'blur',
        },
    ],
    code: [{ required: true, message: '请输入验证码', trigger: 'blur' }]

    // compantName: [{ required: true, message: '请输入公司名称', trigger: 'blur' }],
    // country: [{ required: true, message: '请选择所属国家', trigger: 'change' }],
    // contactInformation: [{ required: true, message: '请输入联系方式', trigger: 'blur' }],
    // companyAddress: [{ required: true, message: '请输入公司地址', trigger: 'blur' }]
};

const formrules = {
        password: [
        { required: true, message: '请输入密码', trigger: 'blur' },
        { min: 6, message: '密码长度至少为6位', trigger: 'blur' },
    ],
    confirmPassword: [
        { required: true, message: '请确认密码', trigger: 'blur' },
        { validator: validateConfirmPassword, trigger: 'blur' },
    ],
}
const sendVerificationCode = () => {
    // 检查是否输入了邮箱
    if (!registerForm.email) {
        ElMessage.warning('请先输入邮箱');
        return;
    }
    sendCode1({ email: registerForm.email }).then(res => {
        if (res.data.code == 200) {
            ElMessage.success('发送成功');
            // 启动倒计时
            canSendCode.value = false;
            const timer = setInterval(() => {
                countdown.value--;
                if (countdown.value <= 0) {
                    clearInterval(timer);
                    canSendCode.value = true;
                    countdown.value = 60;
                }
            }, 1000);
        } else {
            ElMessage.error(res.data.msg);
        }
    })

}
const next = () => {
    // 检查是否有必填字段为空
    const emptyFields = Object.keys(registerForm).filter(
        key => rules[key] && rules[key].some(rule => rule.required) && !registerForm[key]
    );
    if (emptyFields.length > 0) {
        // 有必填字段为空，提示用户并阻止注册
        ElMessage.error('请填写所有必填字段');
        return;
    }
    let obj = {
        userName: registerForm.useName,
        email: registerForm.email,
        code: registerForm.code
    }
    forgetPassword(obj).then(res => {
        if (res.data.code == 200) {
            active.value = 2
        } else {
            ElMessage.error(res.data.msg);
            return
        }
    })
    // active.value = 2
}

const confirm = () => {
    const passwordFields = Object.keys(passwordForm).filter(
        key => formrules[key] && formrules[key].some(rule => rule.required) && !passwordForm[key]
    );
    if (passwordFields.length > 0) {
        // 有必填字段为空，提示用户并阻止注册
        ElMessage.error('请填写所有必填字段');
        return;
    }
    if(passwordForm.password !=passwordForm.confirmPassword ) {
        ElMessage.error('两次密码输入不一致');
        return;
    }
    let obj = {
            userName: registerForm.useName,
            password:passwordForm.password
        }
    changePassword(obj).then(res => {
        if(res.data.code == 200) {
            ElMessage.success('修改成功');
            router.push("/")
        }
    })
}
const backBtn = () => {
    router.push("/")
}
</script>

<style scoped>
* {
    margin: 0;
    padding: 0;
}

.login_header {
    /* height: 80px; */
    display: flex;
    padding-bottom: 15px;
    justify-content: space-around;
}

.logo {
    width: 84px;
    height: 69px;
    margin-top: 15px;
}

.dengluBtn {
    background-color: #F7B02D;
    color: #333;
    /* width: 113px; */
    height: 43px;
    font-weight: 700;
    border: 0;
    padding: 0 10px;
    margin-top: 29px;
}

.trends {
    height: 179px;
    background: url("../../assets/img/login_bg.png") no-repeat;
    background-size: 100% 100%;
    text-align: left;
    padding-left: 440px;
    padding-top: 48px;
}

.kehuzhuce {
    text-align: left;
    font-size: 18px;
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    color: #002FA7;
    /* width: 72px; */
    border-bottom: 1px solid #467DEF;
    padding-bottom: 20px;
}

.information {
    /* height: 362px; */
    background: #FFFFFF;
    border-radius: 10px 10px 10px 10px;
    margin-top: 27px;
    overflow: hidden;
    padding-bottom: 32px;
}

.title {
    font-size: 16px;
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    color: #333333;
    text-align: left;
    margin-top: 20px;
    margin-left: 42px;
    border-bottom: 1px solid #DDDDDD;
    padding-bottom: 12px;
    margin-right: 39px;
}

::v-deep .el-input {
    width: 246px;
    height: 38px;
    background: #FFFFFF;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    border: 1px solid #DDDDDD;
}

::v-deep .el-form-item__label {
    font-size: 14px;
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    color: #333333;
}

::v-deep .el-form-item {
    margin-top: 20px;
}

.yanzhengBtn {
    width: 96px;
    height: 38px;
    background: #002FA7;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    border: 1px solid #DDDDDD;
    font-size: 14px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    margin-left: 19px;
}

.upload {
    width: 131px;
    height: 38px;
    background: #002FA7;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    border: 1px solid #DDDDDD;
    font-size: 14px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
}

.register_bottom {
    height: 81px;
    background-color: #fff;
}

.register_bottom {
    height: 81px;
    background: #FFFFFF;
    border-radius: 10px 10px 10px 10px;
    opacity: 1;
    margin-top: 17px;
    display: flex;
}

.shenheBtn {
    width: 300px;
    height: 40px;
    background: #002FA7;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    font-size: 16px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    color: #FEFEFE;
    margin-left: 67px;
    margin-top: 23px;
}

::v-deep .el-message {
    padding: 10px;
}

::v-deep .custom-step .el-step__icon {
    width: 39px;
    height: 39px;
    background: #002FA7;
    opacity: 1;
    border: 1px solid #DDDDDD;
    color: #fff;
}

::v-deep .xiugai-step .el-step__icon {
    width: 39px;
    height: 39px;
    background: #DDDDDD;
    opacity: 1;
    border: 1px solid #DDDDDD;
    color: #fff;
}

.yanzhengxinxi {
    margin: 12px 440px;
    padding-top: 20px;
    background: #FFFFFF;
    border-radius: 10px 10px 10px 10px;
    opacity: 1;
    padding-bottom: 30px;
}

.next {
    width: 300px;
    height: 40px;
    background: #002FA7;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    color: #fff;
    text-align: center;
    line-height: 40px;
    margin-top: 21px;
    margin-left: 67px;
}

::v-deep .el-step__title.is-finish {
    font-size: 16px;
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    color: #333333;
}

::v-deep .cus-steps .el-step__title.is-process {
    font-weight: 400;
    font-size: 16px;
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    color: #818AA0;
}

::v-deep.cus-steps .el-step__icon.is-text {
    width: 39px;
    height: 39px;
    background: #002FA7;
    opacity: 1;
    border: 1px solid #DDDDDD;
    color: #fff;
}

::v-deep .el-step.is-horizontal .el-step__line {
    top: 18px;
}

::v-deep .cus-steps .el-step__head.is-process .el-step__icon.is-text {
    width: 39px;
    height: 39px;
    background: #DDDDDD;
    opacity: 1;
    border: 1px solid #DDDDDD;
    color: #fff;
}</style>
